(() => {
  const root = document.querySelector('[data-live-root]');
  if (!root) return;

  const apiBase = (root.dataset.apiBase || '').replace(/\/$/, '');
  const streamId = root.dataset.streamId || 'fashionistaway-main';
  const customerId = root.dataset.customerId;
  const customerName = root.dataset.customerName || 'Customer';
  const video = root.querySelector('[data-live-video]');
  const status = root.querySelector('[data-live-status]');
  const overlay = root.querySelector('[data-comments-overlay]');
  const reactions = root.querySelector('[data-floating-reactions]');
  const viewerCount = root.querySelector('[data-viewer-count]');
  const replayList = root.querySelector('[data-replay-list]');
  const input = root.querySelector('[data-comment-input]');
  const sendBtn = root.querySelector('[data-send-comment]');
  const emojiBtns = root.querySelectorAll('[data-send-emoji]');
  const statComments = root.querySelector('[data-stat-comments]');
  const statEmojis = root.querySelector('[data-stat-emojis]');
  const statViewers = root.querySelector('[data-stat-viewers]');

  let comments = 0;
  let emojis = 0;

  async function api(path, options = {}) {
    if (!apiBase || apiBase.includes('your-live-app')) throw new Error('Backend API not configured');
    const res = await fetch(`${apiBase}${path}`, { credentials: 'include', ...options });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  function setStats(next = {}) {
    if (typeof next.commentCount === 'number') comments = next.commentCount;
    if (typeof next.emojiCount === 'number') emojis = next.emojiCount;
    if (statComments) statComments.textContent = comments;
    if (statEmojis) statEmojis.textContent = emojis;
    if (typeof next.viewerCount === 'number') {
      viewerCount.textContent = `${next.viewerCount} watching`;
      if (statViewers) statViewers.textContent = next.viewerCount;
    }
  }

  function showComment(comment) {
    const el = document.createElement('div');
    el.className = 'fw-live__comment';
    el.innerHTML = `<strong></strong><span></span>`;
    el.querySelector('strong').textContent = comment.customerName || 'Viewer';
    el.querySelector('span').textContent = comment.message || comment.emoji || '';
    overlay.appendChild(el);
    while (overlay.children.length > 7) overlay.removeChild(overlay.firstChild);
  }

  function floatEmoji(emoji) {
    const el = document.createElement('div');
    el.className = 'fw-live__reaction';
    el.textContent = emoji;
    el.style.right = `${Math.floor(Math.random() * 26)}px`;
    reactions.appendChild(el);
    setTimeout(() => el.remove(), 1700);
  }

  function loadHls(url) {
    if (!url) return;
    if (window.Hls && window.Hls.isSupported()) {
      const hls = new window.Hls({ lowLatencyMode: true });
      hls.loadSource(url);
      hls.attachMedia(video);
    } else {
      video.src = url;
    }
  }

  async function loadReplays() {
    try {
      const replays = await api(`/api/live/${encodeURIComponent(streamId)}/replays`);
      replayList.innerHTML = replays.length ? '' : 'No saved broadcasts yet.';
      replays.forEach((r) => {
        const card = document.createElement('article');
        card.className = 'fw-live__replay';
        const date = new Date(r.startedAt).toLocaleString();
        card.innerHTML = `<strong>${date}</strong><div class="fw-live__meta">${r.commentCount || 0} comments • ${r.emojiCount || 0} emojis</div><video controls playsinline src="${r.recordingUrl || ''}"></video>`;
        replayList.appendChild(card);
      });
    } catch (e) {
      replayList.textContent = 'Saved broadcasts will show here after the backend is connected.';
    }
  }

  async function init() {
    try {
      const live = await api(`/api/live/${encodeURIComponent(streamId)}`);
      status.textContent = live.isLive ? 'LIVE' : 'Offline';
      setStats(live);
      loadHls(live.playbackUrl || live.recordingUrl);
    } catch (e) {
      status.textContent = 'Setup needed';
      viewerCount.textContent = '0 watching';
    }

    loadReplays();

    try {
      const events = new EventSource(`${apiBase}/api/live/${encodeURIComponent(streamId)}/events`);
      events.addEventListener('comment', (e) => { const c = JSON.parse(e.data); comments += 1; setStats(); showComment(c); });
      events.addEventListener('emoji', (e) => { const c = JSON.parse(e.data); emojis += 1; setStats(); floatEmoji(c.emoji || '❤️'); });
      events.addEventListener('stats', (e) => setStats(JSON.parse(e.data)));
      events.addEventListener('replay-ready', loadReplays);
    } catch (e) {}
  }

  async function send(message = '', emoji = '') {
    if (!customerId) return;
    const payload = { customerId, customerName, message, emoji };
    if (emoji) floatEmoji(emoji); else showComment(payload);
    await api(`/api/live/${encodeURIComponent(streamId)}/comments`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    });
  }

  sendBtn?.addEventListener('click', async () => {
    const message = input.value.trim();
    if (!message) return;
    input.value = '';
    try { await send(message); } catch (e) { console.error(e); }
  });
  input?.addEventListener('keydown', (e) => { if (e.key === 'Enter') sendBtn?.click(); });
  emojiBtns.forEach((btn) => btn.addEventListener('click', () => send('', btn.dataset.sendEmoji || '❤️')));

  init();
})();
